export default __webpack_public_path__ + "static/media/logo_copan.105220a0.webp";